module.exports = __webpack_public_path__ + "img/4.1d453b63.png";